<template>
    <ListShell style="min-height:600px;">
        <template v-if="type == 1">
            <div style="width:400px;display:inline-block;vertical-align: top;">
                <Card @click="isShowCreate = true" title="I do not have an account for training&certification system" tip="Create an new account"></Card>
            </div>
            <div style="width:400px;display:inline-block;margin-left:100px;vertical-align: top;">
                <Card @click="isShowBind = true" title="I have already have an account for training&certification system
Note：If you already have a learning system account, it is recommended to log in with an existing account. If you choose to recreate, the progress on the training&certification system will not be synchronized." tip="Login with an existed account"></Card>  
            </div>
        </template>
        <template v-if="type == 2">
            <div style="padding:20px;">You have bound the account of the learning system.Click E-learning again to enter training&certification system</div>
        </template>
        
        <BindBox v-if="isShowBind" @close="isShowBind = false" @update="getStatus"></BindBox>
        <CreateBox v-if="isShowCreate" @close="isShowCreate = false" @update="getStatus"></CreateBox>
    </ListShell>
</template>
<script>
import Card from "@/components/common/Card.vue";
import ListShell from "@/components/common/ListShell.vue";
import BindBox from "@/components/Learn/BindBox.vue";
import CreateBox from "@/components/Learn/CreateBox.vue";
export default {
    components: {
        Card,
        ListShell,
        BindBox,
        CreateBox
    },
    data () {
        return {
            isShowBind:false,
            isShowCreate:false,
            type:1
        };
    },
    created () {
        this.getStatus();
    },
    methods:{
        getStatus () {
            this.$http.get('checkBindOtherSys',{
                Type:'learning'
            },(data)=>{
                let status = data.data.Status;
                if(status === 0) {
                    this.type = 1;
                }else{
                    this.type = 2;
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>

</style>